import { SORTING_DIR } from "@/common/models";
import { ITableConfig } from "@/components/table/table.model";

export const table_config: ITableConfig = {
  columns: [
    {
      name: "",
      key: "menu",
      spanMin: "4rem",
      spanMax: "4rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: true,
    },
    {
      name: "Site",
      key: "site",
      spanMin: "22rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      jsPath: "$[*].name",
    },
    {
      name: "Type",
      key: "type",
      spanMin: "10rem",
      spanMax: "15rem",
      sortable: false,
      filterable: false,
      jsPath: "$[*].name",
    },
    {
      name: "Owners",
      key: "owners",
      spanMin: "15rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].label",
    },
  ],
};
